import React from 'react';
import { Badge, Link, TextStyle } from '@superops/ui-design-system';
import { injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import {
  KB_CONSTANTS,
  KB_ROUTE_ID
} from '@nile/rmm/src/modules/knowledge-base/constants/kb-constants';
import { useKbContext } from '@nile/rmm/src/modules/knowledge-base';

const CollectionCell = (props) => {
  const { cell } = props;
  const { itemType, status, visibilityType, articleType } = cell?.row?.original;
  const { actions } = cell?.column || {};

  const { activeViewConfig } = useKbContext();

  const DRAFT_STATE = 'DRAFT';
  const VISIBILITY_TYPE_PRIVATE = 'PRIVATE';

  const isDraftView =
    activeViewConfig?.data?.selectedViewId === KB_ROUTE_ID.DRAFT;

  const getIconName = (visibilityType, itemType, articleType) => {
    if (visibilityType === VISIBILITY_TYPE_PRIVATE) {
      return 'PrivateArticle';
    }
    if (itemType === KB_CONSTANTS.KB_COLLECTION) {
      return 'FolderClosed';
    }
    if (articleType === 'PDF') {
      return 'PdfFile';
    }
    return 'AllArticle';
  };

  return (
    <div className="fx actr fx-sb">
      <div className="fx actr g10 ellipsis w100">
        <div className="fx actr">
          <SVGIcon
            name={getIconName(visibilityType, itemType, articleType)}
            size="lg"
          />
        </div>
        <Link
          ellipsis
          onClick={actions?.onClick?.bind(this, cell?.row?.original)}
        >
          {cell.value}
        </Link>
      </div>
      {status === DRAFT_STATE && !isDraftView && (
        <div className="mr10">
          <Badge>
            <TextStyle>{status}</TextStyle>
          </Badge>
        </div>
      )}
    </div>
  );
};

export default injectIntl(CollectionCell);
